import axios from 'axios'

export const getCountries = () => {
  return axios.get('route/countries')
    .then(res => res)
    .catch(err => {
      // console.log('dor', token)
      console.log('err', err, err.response)
      throw err.response
    })
}

export const getCityByCountry = (idCountry) => {
  return axios.get(`route/city/${idCountry}`)
    .then(res => res)
    .catch(err => {
      // console.log('dor', token)
      console.log('err', err, err.response)
      throw err.response
    })
}

export const getProvinces = () => {
  return axios.get(`route/provinces`)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err.response)
      throw err.response
    })
}

export const getProvincesByCountryId = (countryId) => {
  return axios.get(`route/province/${countryId}`)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err.response)
      throw err.response
    })
}

export const getCities = () => {
  return axios.get(`route/cities`)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err.response)
      throw err.response
    })
}

export const getCitiesByCountryId = (countryId) => {
  return axios.get(`route/cities/${countryId}`)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err.response)
      throw err.response
    })
}

export const getCitiesByProvinceId = (provinceId) => {
  return axios.get(`route/city/province/${provinceId}`)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err.response)
      throw err.response
    })
}

export const getDistricts = () => {
  return axios.get(`route/districts`)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err.response)
      throw err.response
    })
}

export const getDistrictsByCityId = (cityId) => {
  return axios.get(`route/district/${cityId}`)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err.response)
      throw err.response
    })
}

export const getSubDistricts = () => {
  return axios.get(`route/subdistricts`)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err.response)
      throw err.response
    })
}

export const getSubDistrictsByDistrictId = (districtId) => {
  return axios.get(`route/subdistrict/${districtId}`)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err.response)
      throw err.response
    })
}



// WEBPACK FOOTER //
// ./src/api/country.api.js